import React from "react";
import { useLocation } from "react-router-dom";
import { AuthenticatedLayout } from "@/components/layout/AuthenticatedLayout";
import { Group, MapPin } from "iconoir-react";

interface GroupData {
  id: string;
  name: string;
  description: string;
  location: string;
  memberCount: number;
  avatar?: string;
  coverImage?: string;
}

const GroupDetailPage: React.FC = () => {
  const location = useLocation();
  const group = location.state?.group as GroupData;

  // Default group data if none provided
  const defaultGroup: GroupData = {
    id: "1",
    name: "Nhận nuôi thú cưng",
    description: "Chào mừng bạn đến với nhóm nhận nuôi thú cưng",
    location: "Hà Nội",
    memberCount: 2000,
    avatar: "/images/thucung.png",
    coverImage: "https://placehold.co/343x152",
  };

  const groupData = group || defaultGroup;

  return (
    <AuthenticatedLayout backgroundColor="#FBF6F1">
      <div className="w-full px-4 py-2 inline-flex flex-col justify-start items-start gap-2.5">
        <div className="self-stretch h-80 relative bg-[#FBF6F1] rounded-md shadow-[0px_1px_4px_0px_rgba(12,12,13,0.05)]">
          <div className="w-full h-36 left-0 top-0 absolute rounded-md">
            <img
              className="w-full h-36 left-0 top-0 absolute rounded-tl-md rounded-tr-md object-cover"
              src={groupData.coverImage}
              alt="Group cover"
            />
            <div className="size- p-3 right-2 top-2 absolute bg-[#F4E7DA] rounded-full shadow-[0px_1px_4px_0px_rgba(12,12,13,0.05)] inline-flex justify-start items-center gap-2.5">
              <div className="size-6 relative overflow-hidden">
                <div className="size-2 left-[8.25px] top-[8.25px] absolute " />
                <div className="size-5 left-[1.25px] top-[1.25px] absolute " />
              </div>
            </div>
          </div>
          <div className="w-full py-4 left-3 top-[82px] absolute inline-flex justify-start items-center gap-9">
            <div className="size- inline-flex flex-col justify-start items-start gap-2">
              <div className="size-24 relative">
                <img
                  className="size-24 left-0 top-0 absolute rounded-full outline outline-[3px] outline-[#FBF6F1] object-cover"
                  src={groupData.avatar}
                  alt="Group avatar"
                />
              </div>
              <div className="size- flex flex-col justify-start items-start gap-1.5">
                <div className="justify-start text-[#1E3A3A] text-2xl font-semibold font-manrope leading-7">
                  {groupData.name}
                </div>
                <div className="size- flex flex-col justify-start items-start gap-1.5">
                  <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                    {groupData.description}
                  </div>
                  <div className="size- flex flex-col justify-start items-start gap-2">
                    <div className="size- inline-flex justify-start items-center gap-1">
                      <div className="size-4 relative overflow-hidden">
                        <Group className="w-4 h-4 text-[#6F6F6B]" />
                      </div>
                      <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                        {groupData.memberCount} thành viên
                      </div>
                    </div>
                    <div className="size- inline-flex justify-start items-center gap-1">
                      <div className="size-3.5 relative overflow-hidden">
                        <MapPin className="w-3.5 h-3.5 text-[#6F6F6B]" />
                      </div>
                      <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                        {groupData.location}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
};

export default GroupDetailPage;
